import { throwError } from 'rxjs';
import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class ErrorHandlingService {
  constructor(private readonly router: Router) {}

  handleHttpError = (error: HttpErrorResponse) => {
    const { error: httpErrorResponse, status } = error;

    if (status === 401) {
      this.router.navigate(['login']);
    }

    if (httpErrorResponse instanceof ErrorEvent) {
      console.error('An error occurred:', httpErrorResponse.message);
    } else {
      console.error(
        `Backend returned code ${status}, ` + `body was: ${httpErrorResponse}`
      );
    }

    return throwError({
      status,
      error,
      customErrorMessage: 'Something bad happened; please try again later.',
    });
  };
}
